/*
 * Ryan O'Dowd
 * 2025-06-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const StoreReview = {
  requestReview: () => {},
};

export default StoreReview;
